export const IS_VERCEL_PROD = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
export const BLOG_PAGE_SIZE = 30
export const ALGOLIA_INDEX_NAME = 'blog'
